import * as React from "react";
import {
	FiPackage,
	FiHome,
	FiEdit2,
	FiUsers,
	FiBarChart2,
} from "react-icons/fi";
import { VStack, Heading, Box, Link, LinkProps } from "@chakra-ui/react";
import { TimelineItem } from "./Timeline";
import { PageSlideFade } from "./page-transitions";
import { Link as NavLink } from "react-router-dom";
import Header from "./header";

interface ExternalLinkProps extends LinkProps {
	url: string;
	linkProps?: LinkProps;
	text: string;
}

const ExternalLink: React.FC<ExternalLinkProps> = ({
	url,
	linkProps,
	text,
	...props
}) => {
	return (
		<Link href={url} {...linkProps} {...props}>
			{text}
		</Link>
	);
};

const InternalLink: React.FC<ExternalLinkProps> = ({
	url,
	linkProps,
	text,
	...props
}) => {
	return (
		<Link as={NavLink} to={url} {...linkProps} {...props}>
			{text}
		</Link>
	);
};
const Achievements = () => {
	return (
		<PageSlideFade>
			<Box alignItems={"start"} mb={6}>
				<Header mt={0} mb={0} underlineColor={""}>
					Achievements
				</Header>
			</Box>
			<VStack textAlign="start" align="start" mb={5}>
				<Box>
					<Heading fontSize="2xl" fontWeight="600" my={5}>
						2023
					</Heading>
					<Box>
						<TimelineItem icon={FiEdit2} skipTrail>
							Wrote 1 blog posts
							<ExternalLink
								color={"blue.200"}
								url="https://blog.errorbaker.tw/posts/ruofan/"
								target="_blank"
								text={""}
							/>
							.
						</TimelineItem>
					</Box>
				</Box>
			</VStack>
			<VStack textAlign="start" align="start" mb={5}>
				<Box>
					<Heading fontSize="2xl" fontWeight="600" my={5}>
						2022
					</Heading>
					<Box>
						<TimelineItem icon={FiEdit2} skipTrail>
							Wrote 8 blog posts
							<ExternalLink
								color={"blue.200"}
								url="https://blog.errorbaker.tw/posts/ruofan/"
								target="_blank"
								text={""}
							/>
							.
						</TimelineItem>
					</Box>
				</Box>
			</VStack>
			<VStack textAlign="start" align="start" mb={5}>
				<Box>
					<Heading fontSize="2xl" fontWeight="600" my={5}>
						2021
					</Heading>
					<Box>
						<TimelineItem icon={FiEdit2} skipTrail>
							Wrote 6 blog posts
							<ExternalLink
								color={"blue.200"}
								url="https://blog.errorbaker.tw/posts/ruofan/"
								target="_blank"
								text={""}
							/>
							.
						</TimelineItem>
					</Box>
					<Box>
						<TimelineItem icon={FiHome} skipTrail>
							Published my first post on this website{" "}
							<ExternalLink
								color={"blue.200"}
								url="https://blog.errorbaker.tw/posts/ruofan/"
								text={"Blog"}
								target="_blank"
							/>
							.
						</TimelineItem>
					</Box>
					<Box>
						<TimelineItem icon={FiPackage} skipTrail>
							Contributed to{" "}
							<ExternalLink
								color={"blue.200"}
								url="https://github.com/Lidemy/error-baker-blog"
								text={"error baker blog"}
								target="_blank"
							/>
							.
						</TimelineItem>
					</Box>
				</Box>
			</VStack>
		</PageSlideFade>
	);
};

export default Achievements;
